/** @jsx jsx */
import { ClassAttributes, } from 'react';
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { Rating, } from '@argo/ui-elements';
import { ExpertReviewAndRating, } from '../../sew-core/types';

const Container = styled.div`
  width: 100%;
`;

const RatingContainer = styled.div`
  padding: 24px 0 16px 0;
  width: 100%;
`;

interface ExpertRatingProps extends ClassAttributes<any> {
  expertReviewAndRating: ExpertReviewAndRating;
}

export default ({ expertReviewAndRating, }: ExpertRatingProps) => {
  const { expertRating, } = expertReviewAndRating;
  const ratings: Array<{text: string; value: number}> = [];
  const lookupText = {
    valueRating: 'Value',
    performanceRating: 'Performance',
    comfortRating: 'Comfort',
    stylingRating: 'Styling',
    overallRating: 'Overall',
  };

  // create an array of expert Rating key and value except overall rating
  for (const ratingType in expertRating) {
    if (ratingType !== 'overallRating' && parseFloat(expertRating[ratingType]) !== 0 && ratingType !== null) {
      ratings.push({
        text: lookupText[ratingType],
        value: parseFloat(expertRating[ratingType] || 0),
      });
    }
  }
  ratings.sort((a, b) => b.value - a.value);

  if(expertRating.overallRating === '' || expertRating.overallRating === '0'){
    return(
      <Container>
        There are no ratings for this vehicle.
      </Container>
    )
  }

  return (
    <Container>
      <Rating size="Medium" text="KBB.com Expert Rating" rating={parseFloat(expertRating.overallRating) || 0} />
      <RatingContainer>
        {
          ratings.map((rating) => (<Rating key={`${rating.text}-${rating.value}`} type="Bar" subType="CategoryHorizontal" text={rating.text} rating={rating.value || 0} />))
        }
      </RatingContainer>
    </Container>
  );
};
